var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _polygon, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10182IconServiceIoTHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa9b6cd1-47ec-44db-bbf1-958203b5601f",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faaeb69b-3035-4577-9cb1-ddd3fba791e3",
    x1: 9.13,
    y1: 18.81,
    x2: 8.85,
    y2: -8.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#22a5cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#29bade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2ec9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#31d1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#32d4f5"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "fa3a22e9-e4e8-46a1-bc09-f9532747c739",
    cx: 11.4,
    cy: 8.44,
    r: 1.97,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "eb214416-6791-4934-ac0c-35afaa829f6e",
    cx: 14.7,
    cy: 14.3,
    r: 1.55,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "a4424413-b91f-48da-aedd-39e3a978b430",
    cx: 8.57,
    cy: 13.24,
    r: 1.33,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "f7ecfc1a-3268-471b-9464-57023bfc9cc4",
    cx: 7.61,
    cy: 3.11,
    r: 1.65,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "b4388938-ad80-41b4-b729-5c21e3eab320",
    cx: 3.19,
    cy: 9.19,
    r: 1.33,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.06 13.99 11.73 8.16 11.4 8.35 11.67 8.15 7.9 2.79 7.21 3.29 10.55 8.04 3.15 8.65 3.22 9.51 10.55 8.9 8.12 12.94 8.85 13.38 11.35 9.22 14.32 14.41 15.06 13.99",
    fill: "#949494"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.53,1.23h0A.73.73,0,0,0,16.8.5H13a.36.36,0,0,0-.36.36V2.27a.36.36,0,0,0,.36.36h2.35v2.3a.38.38,0,0,0,.37.37h1.4a.38.38,0,0,0,.37-.37V1.23Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,15.37H2.61v-2.3a.38.38,0,0,0-.37-.37H.84a.38.38,0,0,0-.37.37v3.7h0a.73.73,0,0,0,.73.72H5a.36.36,0,0,0,.36-.36V15.73A.36.36,0,0,0,5,15.37Z",
    fill: "#949494"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4,6.49a2,2,0,1,1-2,1.95A2,2,0,0,1,11.4,6.49ZM6,3.11A1.66,1.66,0,1,0,7.62,1.46,1.65,1.65,0,0,0,6,3.11ZM1.86,9.18A1.33,1.33,0,1,0,3.19,7.85,1.33,1.33,0,0,0,1.86,9.18Zm5.38,4.05A1.34,1.34,0,1,0,8.58,11.9,1.33,1.33,0,0,0,7.24,13.23Zm5.92,1.07a1.55,1.55,0,1,0,1.55-1.54A1.53,1.53,0,0,0,13.16,14.3Z",
    fill: "url(#faaeb69b-3035-4577-9cb1-ddd3fba791e3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10182IconServiceIoTHub);
export default __webpack_public_path__ + "static/media/10182-icon-service-IoT-Hub.780cdb08f7cab7f08b2071f78636ad51.svg";
export { ForwardRef as ReactComponent };